<template>
  <p class="mb-4 text-lg max-w-lg">
    {{ subTitle }} <slot></slot>
  </p>
</template>

<script>

export default {
  props: {
    subTitle: String
  }
}

</script>
